import React, { FC } from 'react';

import { formatOption }             from '../../../../util';
import { LangService }              from '../../../../services';
import { ORGANIZATIONAL_ROLES }     from '../../../../constants/ProductEnums';
import { ORGANIZATIONAL_ROLE_INFO } from '../../../../constants/ProductEnums';
import { SelectField }              from '../../../components/forms';
import { SelectFieldProps }         from '../formik';

const Dropdown: FC<Omit<SelectFieldProps, 'options'>> = ( props ) => {
	
	let options = [
		formatOption( ORGANIZATIONAL_ROLES.ADMIN, LangService.getTermFromDictionary( ORGANIZATIONAL_ROLE_INFO.ADMIN.LABEL ) ),
		formatOption( ORGANIZATIONAL_ROLES.MEMBER, LangService.getTermFromDictionary( ORGANIZATIONAL_ROLE_INFO.MEMBER.LABEL ) ),
	];
	
	return (
		<SelectField
			{ ...props }
			options={ options }>
		</SelectField>
	);
};

Dropdown.defaultProps = {};

export { Dropdown as OrganizationalRoleDropdown }
